<template>
  <div>
    <PageHeader title="Rate Players"></PageHeader>
    <div>Don't rate players who didn't play.</div>
    <v-container class="pa-0">
      <v-row>
        <v-col>
          <div v-if="pageReady">
            <v-container class="pa-0 mb-4">
              <v-row>
                <v-col cols="1">
                  <ClubIcon 
                  :name="competition.ownClubName"
                  :shield="competition.ownClubShield"
                  :ball="competition.ownClubBallColour"
                  ></ClubIcon>
                </v-col>
                <v-col cols="11" class="pt-4 pl-5">{{competition.ownTeamName}}</v-col>
              </v-row>
            </v-container>
          </div>
            <v-card
              outlined
              v-for="matchPlayer in matchPlayerRatingsCombinedList" :key="matchPlayer.id"
              class="mb-4"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-container class="pa-0">
                    <v-row>
                      <v-col cols="2">
                        <img :src="matchPlayer.photoUrl" :alt="matchPlayer.playerName" style="height: 43px;">
                      </v-col>
                      <v-col cols="10">
                        <v-rating
                          v-model="matchPlayer.rating"
                          background-color="orange lighten-3"
                          color="orange"
                          clearable
                          large
                          @input="handleRate(matchPlayer.playerId, matchPlayer.rating, matchPlayer.entryRateId, matchPlayer.id)"
                        ></v-rating>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col cols="8">
                        {{matchPlayer.playerName}}
                      </v-col>
                      <v-col cols="4" class="small-text text-right">
                        {{matchPlayer.positionName}}
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <v-btn
              block
              outlined
              large
              style="color: #ffffff !important;border: 1px solid #ffb300;"
              color="success"
              class="mt-5"
              type="button"
              @click="submitRatings()"
            >
              Submit Ratings
            </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-link :to="{name: 'entry-home', query: {entryId: $route.query.entryId}}">Back to entry home</router-link>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="showDialog"
      scrollable
      overlay-opacity="0.9"
    >
      <v-card>
        <v-card-title>Submit Ratings</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="color:#ffffff;" class="honeyBold">
          <p>
            To earn your Honey Points and ensure your players get their rating, make sure you hit the Submit Ratings button.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="fanhiveHoney"
            text
            @click="showDialog = false"
          >
            Continue Rating
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="fanhiveHoney"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
            @click="submitRatings()"
          >
            Submit Ratings
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay
      :absolute="false"
      :value="overlay"
      :opacity="0.9"
      >
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import ClubIcon from './ClubIcon';
import axios from 'axios';
import _ from "lodash";
import Socket from "./../../plugins/socket";

export default {
  name: 'rateplayers',
  components: {
    PageHeader,
    ClubIcon
  },
  data: () => ({
    entry: null,
    competition: null,
    overlay: false,
    matchPlayerRatingsCombinedList: null,
    requiredUpdates: 2,
    updatesReceived: 0,
    showDialog: false
  }),
  computed: {
    pageReady () {
      return this.entry !== null && 
      this.matchPlayerRatingsCombinedList !== null && 
      this.competition !== null;
    },
    updatingWalletHoneyPoints () {
      return this.$store.getters.updatingWalletHoneyPoints;
    },
    updatingEntry () {
      return this.$store.getters.updatingEntry;
    },
    displayNoSubmitDialog () {
      return this.$store.getters.displayNoSubmitDialog;
    }
  },
  methods: {
    reconnect: function () {
      var scope = this;
      console.log('Connectionid is null when submitting ratings, must get new one.');
      Socket.connect(scope.$store.getters.userSub.userName);
      setTimeout(() => {
        scope.submitRatings();
      }, 2500);
    },
    updateEntryRate: function (matchPlayerId, newEntryRateId) {
      var scope = this;
      var localMatchPlayerRatingsCombinedList = _.clone(scope.matchPlayerRatingsCombinedList);
      _.forEach(localMatchPlayerRatingsCombinedList, (localMatchPlayerRating) => {
        if (localMatchPlayerRating.id === matchPlayerId) {
          localMatchPlayerRating.entryRateId = newEntryRateId;
        }
      });
      scope.matchPlayerRatingsCombinedList = localMatchPlayerRatingsCombinedList;

      scope.saveNoSubmitRatingCount();
    },
    handleRate: function (playerId, rating, entryRateId, matchPlayerId) {
      var scope = this;
      if (!rating && entryRateId) {
        axios.delete(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entry-rates/${entryRateId}`, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(function () {
            console.log('Rating deleted');
            scope.updateEntryRate(matchPlayerId, null);
          })
          .catch(function (error) {
            console.log(error);
          });
        return;
      }

      if (!entryRateId) {
        axios.post(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entry-rates`, {
          entryId: scope.$route.query.entryId,
          playerId: playerId,
          rating: rating
        }, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(function (response) {
            console.log('New rate submitted');
            var newEntryRateId = response.data.id;
            scope.updateEntryRate(matchPlayerId, newEntryRateId);
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        axios.put(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entry-rates/${entryRateId}`, {
          entryId: scope.$route.query.entryId,
          playerId: playerId,
          rating: rating
        }, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(function () {
            console.log('Rate change submitted');
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getMatchPlayers: function () {
      var scope = this;
      console.log('Getting match players');

      if (scope.matchPlayerRatingsCombinedList)
        scope.matchPlayerRatingsCombinedList = null;

      axios.get(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/match-players?matchId=${scope.$route.query.matchId}`, {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      })
        .then(function (matchPlayersResponse) {
          var localMatchPlayers = matchPlayersResponse.data;
          axios.get(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entry-rates?entryId=${scope.$route.query.entryId}`, {
            headers: {
              'Authorization': localStorage.getItem('jwtToken')
            }
          })
            .then(function (entryRatesResponse) {
              var localEntryRates = entryRatesResponse.data;
              var localCombinedList = [];
              _.forEach(localMatchPlayers, (localMatchPlayer) => {
                var localCombined = {
                  id: localMatchPlayer.id,
                  playerId: localMatchPlayer.playerId,
                  number: localMatchPlayer.number,
                  playerName: localMatchPlayer.playerName,
                  positionName: localMatchPlayer.positionName,
                  photoUrl: localMatchPlayer.photoUrl,
                  entryRateId: null
                }
                var entryRate = _.find(localEntryRates, (o) => {
                  return o.playerId === localMatchPlayer.playerId;
                });
                if (entryRate) {
                  localCombined.rating = entryRate.rating;
                  localCombined.entryRateId = entryRate.id;
                }
                localCombinedList.push(localCombined);
              });

              scope.matchPlayerRatingsCombinedList = localCombinedList;

              scope.getEntry();
              
              scope.saveNoSubmitRatingCount();
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getEntry: function () {
      var scope = this;
      this.$store.dispatch('getEntry', this.$route.query.entryId).then(getEntryResponse => {
        scope.entry = getEntryResponse;
        scope.getCompetition(scope.entry.competitionId);
      }, error => {
          console.log(error);
      });
    },
    getCompetition: function (competitionId) {
      var scope = this;
      this.$store.dispatch('getCompetition', competitionId).then(getCompetitionResponse => {
        scope.competition = getCompetitionResponse;
        scope.overlay = false;
      }, error => {
          console.log(error);
      });
    },
    updateWallet(){
      var scope = this;
      this.$store.dispatch('getWallet', this.$store.getters.userSub.id).then(response => {
          scope.$localStorage.set('wallet', JSON.stringify(response));
          scope.$store.commit('setWallet', response);
          scope.$store.commit('setUpdatingEntry', 0);
          scope.$store.commit('setUpdatingWalletHoneyPoints', 0);
          scope.overlay = false;
          scope.$router.push({name: 'entry-home', query: { 
            entryId: scope.entry.id
          }});
        }, error => {
            console.log(error);
        })
    },
    submitRatings: function () {
      var scope = this;
      scope.overlay = true;
      scope.showDialog = false;

      if(scope.$store.getters.connectionId === null){
        scope.reconnect();
        return;
      }

      scope.$store.commit('setUpdatingEntry', 1);
      axios.put(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entries/${scope.$route.query.entryId}`, {
        rated: true
      }, {
        headers: {
          'Authorization': localStorage.getItem('jwtToken'),
          connectionid: scope.$store.getters.connectionId
        }
      })
        .then(function () {
          scope.$store.commit('setUpdatingWalletHoneyPoints', 1);
          var slug = "submitted-ratings"
          axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/honey-transactions', {
            userId: scope.$store.getters.userSub.id,
            walletId: scope.$store.getters.wallet.id,
            entryId: scope.$route.query.entryId,
            isDebit: false,
            honeyPointSlug: slug
          }, {
            headers: {
              Authorization: localStorage.getItem('jwtToken'),
              connectionid: scope.$store.getters.connectionId
            }
          })
            .then(function () {
              scope.saveNoSubmitRatingCount(0);
            })
            .catch(function (error) {
              console.log(error);
            });
          
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    saveNoSubmitRatingCount: function (val) {
      if(val === 0){
        this.$store.commit('setNoSubmitRatingCount', 0);
      } else {
        this.$store.commit('setNoSubmitRatingCount', _.filter(this.matchPlayerRatingsCombinedList, function(o) { return o.entryRateId !== null; }).length);
      }
    }
  },
  created () {
    this.overlay = true;
    this.getMatchPlayers();
  },
  watch: {
    updatingEntry (newVal) {
      console.log('updatingEntry ' + newVal);
      if(newVal === 2)
        this.updatesReceived++;
    },
    updatingWalletHoneyPoints (newVal) {
      console.log('updatingWalletHoneyPoints ' + newVal);
      if(newVal === 2)
        this.updatesReceived++;
    },
    updatesReceived (newVal) {
      console.log('required updates: ' + this.requiredUpdates);
      console.log('updates received: ' + newVal);
      if(this.requiredUpdates === newVal)
        this.updateWallet();
    },
    playerOfTheMatchId () {
      this.submitVote();
    },
    displayNoSubmitDialog (val) {
      if(val){
        this.showDialog = true;
        this.$store.commit('setDisplayNoSubmitDialog', false);
      }
    }
  }
}
</script>